<template>
  <a-tabs default-active-key="1" @change="callback">
    <a-tab-pane key="1" tab="资产退货出库">
      <div class="content_main">
        <div class="content_main_top">
          <a-button
            type="primary"
            style="margin-right: 5px"
            @click="show_apply"
            :disabled="selectedRowKeysTabItems.length < 1"
            >资产退货出库</a-button
          >
          <a-input
            placeholder="采购编号"
            allowClear
            v-model="queryParam.purchaseCode"
            class="a_input_self margin_self"
            @keyup.enter.native="serch"
          />
          <a-select
            show-search
            allowClear
            placeholder="公司名称"
            class="margin_self"
            @change="handlecompany"
            v-model="queryParam.companyId"
            @keyup.enter.native="serch"
            style="width: 200px"
          >
            <a-select-option :value="item.deptId" v-for="(item, index) in companylist" :key="index">
              {{ item.title }}
            </a-select-option>
          </a-select>
          <a-tree-select
            allowClear
            :treeData="deptTree"
            v-model="queryParam.deptId"
            placeholder="申请部门"
            @keyup.enter.native="serch"
			:disabled="!queryParam.companyId"
            style="width: 160px"
            class="margin_self"
            treeDefaultExpandAll
          >
          </a-tree-select>
          <a-input
            placeholder="申请人"
            allowClear
            v-model="queryParam.applicant"
            class="a_input_self margin_self"
            @keyup.enter.native="serch"
          />
          <a-input
            placeholder="物品编号"
            allowClear
            v-model="queryParam.assetSn"
            class="a_input_self margin_self"
            @keyup.enter.native="serch"
          />
          <a-input
            placeholder="物品名称"
            allowClear
            v-model="queryParam.name"
            class="a_input_self margin_self"
            @keyup.enter.native="serch"
          />
          <a-input
            placeholder="入库人"
            allowClear
            v-model="queryParam.operator"
            class="a_input_self margin_self"
            @keyup.enter.native="serch"
          />
          <a-button type="primary" style="margin: 5px" @click="serch"> 查询 </a-button>
          <a-button type="primary" ghost @click="result"> 重置 </a-button>
        </div>
        <div class="content_main_center_scroll" id="content_main_center_scroll">
          <a-table
            :data-source="data"
            bordered
            :scroll="{ x: 2200, y: scroll_y }"
            rowKey="id"
            :row-selection="{ selectedRowKeys: selectedRowKeysTab, onChange: onSelectChangeTab, type: 'radio' }"
            :pagination="pagination"
            @change="handleTableChange"
          >
            <a-table-column key="index" title="序号" data-index="index" width="70px">
              <template scope="text, record, index">{{
                (pagination.current - 1) * pagination.pageSize + index + 1
              }}</template>
            </a-table-column>
            <a-table-column
              key="purchaseCode"
              ellipsis="true"
              title="采购编号"
              data-index="purchaseCode"
              width="220px"
            />
            <a-table-column key="companyName" ellipsis="true" title="申请公司" data-index="companyName" />
            <a-table-column key="deptName" ellipsis="true" title="申请部门" data-index="deptName" />
            <a-table-column key="applicant" ellipsis="true" title="申请人" data-index="applicant" />
            <a-table-column key="goosType" ellipsis="true" title="物品类型" data-index="goosType" />
            <!-- <span slot="asset_type" slot-scope="text">
						{{ text ? operTypeMap[text].text : '' }}
					    </span>
						</a-table-column> -->
            <a-table-column key="assetSn" ellipsis="true" title="物品编号" data-index="assetSn" />
            <a-table-column key="name" title="物品名称" data-index="name" />
            <a-table-column key="model" ellipsis="true" title="规格型号" data-index="model" />
            <a-table-column key="amount" ellipsis="true" title="采购数量" data-index="amount" />
            <a-table-column key="unit" ellipsis="true" title="物品单位" data-index="unit" />
            <a-table-column key="dealer" ellipsis="true" title="供应商" data-index="dealer" />
            <a-table-column key="purchaser" ellipsis="true" title="采购人" data-index="purchaser" />
            <a-table-column key="purchaseTime" ellipsis="true" title="采购时间" data-index="purchaseTime" />
            <a-table-column key="operator" ellipsis="true" title="入库人" data-index="operator" />
            <a-table-column key="action" title="操作" data-index="action" fixed="right" width="80px">
              <template scope="text,record">
                <a @click="handelAudit(record)">详情</a>
                <!-- <a-divider type="vertical" />
									<a @click="handFlow(record)">历史</a>
									<a-divider type="vertical" />
									<a :disabled="record.status !== 1" @click="cancel([record.procInstId])">撤销</a> -->
              </template>
            </a-table-column>
          </a-table>
        </div>
      </div>
    </a-tab-pane>
    <a-tab-pane key="2" tab="耗材退货出库">
      <div class="content_main">
        <div class="content_main_top">
          <a-button
            type="primary"
            style="margin-right: 5px"
            @click="show_apply"
            :disabled="selectedRowKeysTabItems.length < 1"
            >耗材退货出库</a-button
          >
          <a-input
            placeholder="采购编号"
            allowClear
            v-model="queryParamspu.purchaseCode"
            class="a_input_self margin_self"
            @keyup.enter.native="serchspu"
          />
          <a-input
            placeholder="品类编号"
            allowClear
            v-model="queryParamspu.spuSn"
            class="a_input_self margin_self"
            @keyup.enter.native="serchspu"
          />
          <a-input
            placeholder="品类名称"
            allowClear
            v-model="queryParamspu.name"
            class="a_input_self margin_self"
            @keyup.enter.native="serchspu"
          />
          <a-input
            placeholder="申请人"
            allowClear
            v-model="queryParamspu.applicant"
            class="a_input_self margin_self"
            @keyup.enter.native="serchspu"
          />
          <a-input
            placeholder="入库人"
            allowClear
            v-model="queryParamspu.operator"
            class="a_input_self margin_self"
            @keyup.enter.native="serchspu"
          />
          <a-button type="primary" style="margin: 5px" @click="serchspu"> 查询 </a-button>
          <a-button type="primary" ghost @click="resultspu"> 重置 </a-button>
        </div>
        <div class="content_main_center_scroll" id="content_main_center_scroll">
          <a-table
            :data-source="data2"
            bordered
            :scroll="{ x: 2200, y: scroll_y }"
            rowKey="id"
            :row-selection="{ selectedRowKeys: selectedRowKeysTab, onChange: onSelectChangeTab }"
            :pagination="pagination2"
            @change="handleTableChangespu"
          >
            <a-table-column key="index" title="序号" data-index="index" width="70px">
              <template scope="text, record, index">{{ (pagination.current - 1) * 10 + index + 1 }}</template>
            </a-table-column>
            <a-table-column
              key="purchaseCode"
              ellipsis="true"
              title="采购编号"
              data-index="purchaseCode"
              width="220px"
            />
            <a-table-column key="companyName" ellipsis="true" title="申请公司" data-index="companyName" />
            <a-table-column key="deptName" ellipsis="true" title="申请部门" data-index="deptName" />
            <a-table-column key="applicant" ellipsis="true" title="申请人" data-index="applicant" />
            <a-table-column key="goosType" ellipsis="true" title="类别" data-index="goosType" />
            <!-- <a-table-column key="asset_type" ellipsis="true" title="类别" data-index="goodsType">
						    <span slot="asset_type" slot-scope="text">
						       {{ text ? operTypeMap[text].text : '' }}
					        </span>
						</a-table-column> -->
            <a-table-column key="spuSn" ellipsis="true" title="品类编号" data-index="spuSn" />
            <a-table-column key="name" ellipsis="true" title="品类名称" data-index="name" />
            <!-- <a-table-column key="name" title="物品名称" data-index="name" /> -->
            <a-table-column key="model" ellipsis="true" title="规格型号" data-index="model" />
            <a-table-column key="dealer" ellipsis="true" title="供应商" data-index="dealer" />
            <a-table-column key="amount" ellipsis="true" title="采购数量" data-index="amount" />
            <a-table-column key="amount" ellipsis="true" title="入库数量" data-index="amount" />
            <a-table-column key="unit" ellipsis="true" title="单位" data-index="unit" />
            <a-table-column key="purchaser" ellipsis="true" title="采购人" data-index="purchaser" />
            <a-table-column key="purchaseTime" ellipsis="true" title="采购时间" data-index="purchaseTime" />
            <!-- <a-table-column key="assetSn" ellipsis="true" title="物品编号" data-index="assetSn" /> -->
            <a-table-column key="operator" ellipsis="true" title="入库人" data-index="operator" />
            <a-table-column key="createTime" ellipsis="true" title="入库时间" data-index="createTime" />
            <a-table-column key="action" title="操作" data-index="action" fixed="right" width="80px">
              <template scope="text,record">
                <a @click="handelAudit(record)">详情</a>
                <!-- <a-divider type="vertical" />
									<a @click="handFlow(record)">历史</a>
									<a-divider type="vertical" />
									<a :disabled="record.status !== 1" @click="cancel([record.procInstId])">撤销</a> -->
              </template>
            </a-table-column>
          </a-table>
        </div>
      </div>
    </a-tab-pane>
    <a-modal
      v-model="is_apply_show"
      :title="key == 1 ? '固定资产-退货出库' : '流动资产-退货出库'"
      width="60%"
      :maskClosable="false"
    >
      <template slot="footer">
        <a-button key="back" @click="is_apply_show = false"> 取消 </a-button>
        <a-button key="submit" type="primary" @click="apply_delivery"> 提交 </a-button>
      </template>
      <a-form-model
        :rules="apply_rules"
        ref="apply_ref"
        :model="apply_info"
        :label-col="labelCol3"
        :wrapper-col="wrapperCol3"
      >
        <a-row>
          <a-form-model-item label="选择抄送人" :label-col="{ span: 3 }" :wrapper-col="{ span: 21 }">
            <ccChange :data="ccC" @targetKeys="getdata" v-if="isRouterAlive" />
          </a-form-model-item>
        </a-row>
        <a-row>
          <a-col :span="24">
            <a-form-model-item
              label="退货原因"
              :label-col="{ span: 3 }"
              :wrapper-col="{ span: 21 }"
              prop="returnReason"
              :rules="{
                required: true,
                message: '请输入退货原因',
                trigger: 'change',
              }"
            >
              <a-input v-model="apply_info.returnReason" placeholder="请输入"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="退货申请图片" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
              <uploadImgJava :data="uploadDataImg" v-if="isRouterAlive" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="退货申请附件" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
              <uploadFileCode :data="uploadData" v-if="isRouterAlive" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-table :data-source="apply_info.old_goods" bordered :pagination="false">
            <a-table-column key="purchaseCode" title="采购编号" ellipsis="true" data-index="purchaseCode" />
             <a-table-column key="assetSn" title="物品编号" ellipsis="true" data-index="assetSn" v-if="key == 1"/>
            <a-table-column key="spuSn" title="物品编号" ellipsis="true" data-index="spuSn" v-else/>
           
            <a-table-column key="name" title="物品名称" ellipsis="true" data-index="name" />
            <a-table-column key="model" title="规格型号" ellipsis="true" data-index="model" />
            <a-table-column key="num" title="退货数量" data-index="num" width="200px">
              <template scope="text,record">
                <a-input type="number" v-model="record.num" @blur="set_max_min(record)" :disabled="key == 1" />
              </template>
            </a-table-column>
            <a-table-column key="unit" title="单位" ellipsis="true" data-index="unit" />
            <a-table-column key="remarks" title="备注" data-index="remarks" width="200px">
              <template scope="text,record">
                <a-input v-model="record.remarks" />
              </template>
            </a-table-column>
            <!-- <a-table-column key="action" title="操作" data-index="action">
								<template scope="text,record">
									<a @click="deletes(record)">删除</a>
								</template>
							</a-table-column> -->
          </a-table>
        </a-row>
      </a-form-model>
    </a-modal>
    <!-- 撤销提示 -->
    <a-modal v-model="is_revocation" title="确认撤销此申请吗?" on-ok="handleOkReason">
      <template slot="footer">
        <a-button key="back" @click="is_revocation = false"> 取消 </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleOkReason"> 撤销 </a-button>
      </template>
      <a-textarea placeholder="请输入原因" v-model="reason" />
    </a-modal>
    <a-modal
      :title="key == 1 ? '固定资产-退货详情' : '流动资产-退货详情'"
      :visible="detailsvisible"
      @cancel="detailsvisible = false"
      width="55%"
    >
      <template slot="footer">
        <a-button key="back" @click="detailsvisible = false"> 取消 </a-button>
      </template>
      <a-form-model :model="detailsrow" :label-col="labelCol" :wrapper-col="wrapperCol">
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="采购编号">
              <span>{{ detailsrow.purchaseCode }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="申请公司">
              <span>{{ detailsrow.companyName }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="申请部门">
              <span>{{ detailsrow.deptName }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="申请人">
              <span>{{ detailsrow.applicant }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="物品类型">
              <span>{{ detailsrow.goosType }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-if="key == 1">
            <a-form-model-item label="物品编号">
              <span
                ><span>{{ detailsrow.assetSn }}</span></span
              >
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-else>
            <a-form-model-item label="品类编号">
              <span
                ><span>{{ detailsrow.spuSn }}</span></span
              >
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12" v-if="key == 1">
            <a-form-model-item label="物品名称">
              <span>{{ detailsrow.name }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-else>
            <a-form-model-item label="品类名称">
              <span>{{ detailsrow.name }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="规格型号">
              <span>{{ detailsrow.model }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12" v-if="key == 1">
            <a-form-model-item label="数量">
              <span>{{ detailsrow.amount }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12" v-else>
            <a-form-model-item label="采购数量">
              <span>{{ detailsrow.amount }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="单位">
              <span>{{ detailsrow.unit }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
        <!-- <a-row>
					<a-col :span="12">
						<a-form-model-item label="供应商">
							<span>{{ detailsrow.dealer }}</span>
						</a-form-model-item>
					</a-col>
				</a-row> -->
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="采购人">
              <span>{{ detailsrow.purchaser }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="采购时间">
              <span>{{ detailsrow.purchaseTime }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row>
          <a-col :span="12">
            <a-form-model-item label="供应商">
              <span>{{ detailsrow.dealer }}</span>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item label="入库人">
              <span>{{ detailsrow.operator }}</span>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </a-modal>
    <proc-flow-modal ref="modalflow" @ok="handleOk" />
  </a-tabs>
</template>

<script>
import { limitCompany } from '@/utils/limitCompany'
import debounce from 'lodash/debounce'
import { purchase_save, tree_all } from '@/api/purchase'
import {
  claim_apply,
  getDeptListEnable,
  get_dept_tree2,
  dict,
  goods_rejected_selectAssetList,
  goods_rejected_code,
  goods_rejected_save,
  goods_rejected_getSpuList,
} from '@/api/assetmenag'
import { delProcessIns, modalMap } from '@/api/activiti'
import { get_dict, returnDept2, get_users } from '@/utils/unit_axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import uploadFileCode from '@/components/module/uploadFileCode.vue'
import uploadImgJava from '@/components/module/uploadImgJava.vue'
import ccChange from '@/components/module/ccChange'
import ProcFlowModal from '../activiti/modules/ProcFlowModal.vue' //历史
import storage from 'store'
const deptMap = {}
export default {
  data() {
    return {
      key: 1,
      uploadData: {
        code: '',
        type: 'goods-rejected-file',
      },
      uploadDataImg: {
        code: '',
        type: 'goods-rejected-img',
      },
      queryParam: {
         deptId: undefined,
        operator: '',
        companyId: undefined,
        purchaseCode: '',
        deptId: undefined,
        applicant: '',
        assetSn: '',
        name: ''
      },
      queryParamspu: {},
      is_revocation: false,
      operTypeMap: {},
      ids: '', //撤销id
      reason: '', //撤销原因
      statusMap: '',
      isRouterAlive: true,
      selectedRowKeysTab: [],
      selectedRowKeysTabItems: [],
      scroll_y: 150,
      deptMap,
      data: '',
      data2: '',
      loading: false,
      date: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
      pagination2: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showLessItems: true,
        showSizeChanger: true,
      },
      apply_rules: {
        reason: [
          {
            required: true,
            message: '请输入申领原因',
            trigger: 'blur',
          },
        ],
      },
      is_apply_show: false,
      apply_info: {
        cc: [],
        returnReason: '',
        old_goods: [],
        applyCode: '',
        purchaseCode: '',
      },
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 7,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
      labelCol2: {
        span: 2,
      },
      wrapperCol2: {
        span: 22,
      },
      labelCol3: {
        span: 8,
      },
      wrapperCol3: {
        span: 16,
      },
      options: [],
      checkAll: false,
      indeterminate: false,
      checkAllOptions: [], //全项
      detailsrow: '',
      detailsvisible: false,
      ccC: 'goodsRejected',
      companylist: [],
      deptlist: [],
      deptTree: [],
    }
  },
  components: {
    ccChange,
    uploadFileCode,
    uploadImgJava,
    ProcFlowModal,
  },
  filters: {
    operTypeFilter(type) {
      return operTypeMap[type].text
    },
    deptFilter(type) {
      return deptMap[type].text
    },
  },
  created() {
    this.get_list()
    this.get_spulist()
    // tree_all().then((res) => {
    //   res.data[0].forEach((item) => {
    //     if (item.deptId == this.$store.state.user.info.companyId) {
    //       this.deptTree = item.children
    //     }
    //   })
    // })
    limitCompany().then((res) => {
      res.forEach((item) => {
        if (item.deptId) {
          this.companylist.push(item)
        }
      })
    })
    // get_dept_tree2().then((res) => {
    // 	this.companylist = res.data.dept_lis
    // 	this.companylist.unshift({
    // 		dept_id: 0,
    // 		dept_name: '所有公司',
    // 		child_lis: [],
    // 	})
    // })
    get_dict('goodStatus', (res) => {
      this.statusMap = res
    })
    dict({
      pageNum: 1,
      pageSize: 10,
      dictType: 'assets_type',
    }).then((res) => {
      this.assettype = res.rows
      this.assettype.map((d) => {
        this.operTypeMap[d.dictCode] = {
          text: d.dictLabel,
        }
      })
    })
    // getDeptListEnable().then((res) => {
    //   const data = res.rows
    //   if (data.length > 0) {
    //     const min = Math.min(...data.map((m) => m.parentId))
    //     this.buildtree2(data, this.deptTree, min)
    //     this.deptTree.map((d) => {
    //       if (d.hasOwnProperty('children')) {
    //         d.children.map((b) => {
    //           deptMap[b.key] = {
    //             text: b.title,
    //           }
    //           deptMap[d.key] = {
    //             text: d.title,
    //           }
    //         })
    //       } else {
    //         deptMap[d.key] = {
    //           text: d.title,
    //         }
    //       }
    //     })
    //     this.expandedKeys = data.map((m) => m.parentId)
    //     this.dataList = data.map((m) => {
    //       return {
    //         key: m.deptId,
    //         title: m.deptName,
    //       }
    //     })
    //   }
    // })
  },
  mounted() {
    returnDept2((res) => {
      this.options = res.depts
    })
    this.$nextTick(() => {
      var max_h = $('#content_main_center_scroll').height()
      setTimeout(() => {
        this.scroll_y = max_h - $('.ant-table-header').height() - 50
      }, 1000)
    })
  },
  methods: {
	  handlecompany(e) {
		  this.deptTree = []
		  this.queryParam.deptId = undefined
		  this.companylist.forEach(item => {
			  if(item.deptId == e) {
				 this.deptTree = item.children
			  }
		  })

	  },
    callback(key) {
      this.key = key
      this.selectedRowKeysTab = []
      this.selectedRowKeysTabItems = []
    },
    handelAudit(row) {
      this.detailsrow = row
      this.detailsvisible = true
    },
    deletes(row) {
      var index = this.selectedRowKeysTab.indexOf(row.goodsId)
      this.selectedRowKeysTab.splice(index, 1)
      this.selectedRowKeysTabItems.splice(index, 1)
    },
    result() {
      this.queryParam = {
        deptId: undefined,
        operator: '',
        companyId: undefined,
        purchaseCode: '',
        deptId: undefined,
        applicant: '',
        assetSn: '',
        name: ''
      }
    },
    resultspu() {
      this.queryParamspu = {}
    },
    // 撤销
    cancel(ids) {
      this.is_revocation = true
      this.ids = ids
      this.reason = ''
    },
    // 撤销提交
    handleOkReason() {
      delProcessIns({
        ids: this.ids.join(','),
        reason: this.reason,
      }).then((res) => {
        if (res.code === 200) {
          this.$message.success('撤销成功')
          this.get_list()
          this.is_revocation = false
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    getdata(data) {
      this.apply_info.cc = data
    },
    //搜索
    serch() {
      this.loading = true
      this.pagination.current = 1
      this.get_list()
    },
    serchspu() {
      this.loading = true
      this.pagination2.current = 1
      this.get_spulist()
    },
    //改变分页
    handleTableChange(pagination, filters, sorter) {
      this.pagination.current = pagination.current
      this.pagination.pageSize = pagination.pageSize
      this.get_list()
    },
    //改变分页
    handleTableChangespu(pagination, filters, sorter) {
      this.pagination2.current = pagination.current
      this.pagination2.pageSize = pagination.pageSize
      this.get_spulist()
    },
    get_list() {
      this.loading = true
      goods_rejected_selectAssetList({
		companyId:  this.queryParam.companyId,
        sortField: 'createTime',
        sortOrder: 'desc',
        pageSize: this.pagination.pageSize,
        pageNum: this.pagination.current,
        name: this.queryParam.name,
        assetSn: this.queryParam.assetSn,
        purchaseCode: this.queryParam.purchaseCode,
        operator: this.queryParam.operator,
        applicant: this.queryParam.applicant,
        deptId: this.queryParam.deptId,
      }).then((res) => {
        this.loading = false
        const pagination = { ...this.pagination }
        pagination.total = res.total
        this.pagination = pagination
        this.data = res.rows
      })
    },
    get_spulist() {
      this.loading = true
      goods_rejected_getSpuList({
        pageSize: this.pagination2.pageSize,
        pageNum: this.pagination2.current,
        name: this.queryParamspu.name,
        spuSn: this.queryParamspu.spuSn,
        // assetSn: this.queryParamspu.assetSn,
        purchaseCode: this.queryParamspu.purchaseCode,
        operator: this.queryParamspu.operator,
        applicant: this.queryParamspu.applicant,
        // name: this.queryParamspu.name
      }).then((res) => {
        
        this.loading = false
        if(res.code == 200) {
            const pagination = { ...this.pagination2 }
            pagination.total = res.total
            this.pagination2 = pagination
            this.data2 = res.rows
        } else {
          this.$message.error(res.msg)
        }
     
      })
    },
    //选择第一个表格
    onSelectChangeTab(selectedRowKeys, selectedRows) {
      var arr = JSON.parse(JSON.stringify(selectedRows))
      this.selectedRowKeysTabItems = this.selectedRowKeysTabItems.concat(arr)
      this.selectedRowKeysTab = selectedRowKeys
      var obj = {}
      this.selectedRowKeysTabItems = this.selectedRowKeysTabItems.reduce(function (item, next) {
        obj[next.id] ? '' : (obj[next.id] = true && item.push(next))
        return item
      }, [])
      var newLis = []
      this.selectedRowKeysTab.forEach((key, idx) => {
        this.selectedRowKeysTabItems.forEach((item, index) => {
          if (key == item.id) {
            newLis.push(item)
          }
        })
      })
      this.selectedRowKeysTabItems = newLis
    },
    get_code() {
      goods_rejected_code().then((res) => {
        this.apply_info.applyCode = res.data
        this.uploadData.code = res.data
        this.uploadDataImg.code = res.data
      })
    },
    show_apply() {
      this.isRouterAlive = false
      this.$nextTick(() => {
        this.isRouterAlive = true
      })
      this.get_code()
      this.apply_info = {
        cc: [],
        returnReason: '',
        old_goods: [],
        applyCode: '',
      }
      this.selectedRowKeysTabItems.forEach((item) => {
        item['num'] = 1
      })
      this.apply_info.old_goods = this.selectedRowKeysTabItems
      this.is_apply_show = true
    },
    // 某项改变
    onChangeFroup(checkedList) {
      this.indeterminate = !!checkedList.length && checkedList.length < this.checkAllOptions.length
      this.checkAll = checkedList.length === this.checkAllOptions.length
    },
    //限制最大值
    set_max_min(row) {
      let max = row.amount
      if (row.num < 1) {
        row.num = 1
      }
      if (row.num > max) {
        row.num = max
      }
      this.$forceUpdate()
    },
    //点击领用出库
    apply_delivery: debounce(
      function () {
        var _this = this
        this.$refs.apply_ref.validate((valid) => {
          if (valid) {
            var lis = []
            _this.apply_info.old_goods.forEach((item) => {
              lis.push({
                assertId: item.id,
                num: item.num,
                remarks: item.remarks,
                itemType: _this.key,
                purchaseCode: item.purchaseCode,
              })
            })
            goods_rejected_save({
              cc: _this.apply_info.cc.length ? _this.apply_info.cc.join(',') : '',
              goodsRejectedDetailList: lis,
              applyCode: _this.apply_info.applyCode,
              returnReason: _this.apply_info.returnReason,
            }).then((res) => {
              if (res.code != 200) {
                this.$message.error(res.msg)
                return
              }
              this.$message.success('提交成功')
              this.get_list()
              this.get_spulist()
              this.is_apply_show = false
              this.selectedRowKeysTab = []
              this.selectedRowKeysTabItems = []
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      1000,
      {
        leading: true,
        trailing: false,
      }
    ),
  },
}
</script>

<style>
.dialog {
  display: flex;
  justify-content: space-between;
}

.flex {
  display: flex;
}

.center {
  text-align: center;
  width: 832px;
}

.dialog .dialog_item {
  margin-bottom: 5px;
  width: 220px;
  display: flex;
  justify-content: space-between;
}

.Exhi {
  display: inline-block;
  border: 1px solid black;
  width: 100px;
  text-align: left;
  color: steelblue;
}
</style>
